// CMS products that moved from Products to AI Solutions, where each now has
// its own static page like BestoFlow / AskOchat (and its own entry in the AI
// landing page, Home "AI That Works for You" and the header AI Solutions menu).
// Their CMS rows may still exist, so every Products listing (Products page
// tabs, Home "In-House Products", header Products menu) skips them, and their
// old Products URLs (/products/:slug, /products?tab=<tab>) redirect to `path`.
// Keep in sync with AI_SOLUTION_SLUGS in Backend/routes/search.js.
export const AI_SOLUTION_MOVES = [
  { slug: "besto-jyotish", tab: "Besto Jyotish", path: "/besto_jyotish" },
];

export const isMovedToAISolutions = (product) =>
  AI_SOLUTION_MOVES.some((m) => m.slug === product?.slug);
